// src/cms/video-upload/view/create-new-article-container.jsx
import React from "react";
import { connect } from "react-redux";
import axios from "axios";

class CreateNewArticleContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      category: "Entertainment",
      file: null,
      error: "",
      uploading: false,
      progress: 0,
      serverMessage: "",
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // --- helpers (no optional chaining for older toolchains) ---
  getAccessToken() {
    try {
      return localStorage.getItem("accessToken") || "";
    } catch (e) {
      return "";
    }
  }

  getActiveDomainObj() {
    var login = this.props && this.props.login ? this.props.login : null;
    if (!login || !login.user) return null;
    return login.user.activeDomain || null;
  }

  getDomainIdFromActiveDomain(activeDomain) {
    if (!activeDomain) return null;
    if (activeDomain.domain_id) return activeDomain.domain_id;
    if (activeDomain.domainId) return activeDomain.domainId;
    if (activeDomain.id) return activeDomain.id;
    return null;
  }

  getApiBase() {
    // e.g. http://localhost:4000
    var base = (typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_BLUE_SERVER) ? process.env.REACT_APP_BLUE_SERVER : "";
    // trim trailing slash
    if (base && base.charAt(base.length - 1) === "/") base = base.slice(0, -1);
    return base;
  }
  // -----------------------------------------------------------

  handleFileChange(e) {
    var files = e && e.target && e.target.files ? e.target.files : null;
    var f = files && files.length ? files[0] : null;

    if (!f) {
      this.setState({ file: null, error: "" });
      return;
    }

    var isMp4 =
      (f.type && f.type.indexOf("mp4") !== -1) ||
      (f.name && f.name.toLowerCase().slice(-4) === ".mp4");

    if (!isMp4) {
      this.setState({ error: "Please select an MP4 file.", file: null });
      return;
    }

    this.setState({ file: f, error: "" });
  }

  handleSubmit(e) {
    e.preventDefault();
    var title = (this.state.title || "").trim();

    if (!title || !this.state.file) {
      this.setState({ error: "Title and MP4 file are required." });
      return;
    }

    var accessToken = this.getAccessToken();
    var activeDomain = this.getActiveDomainObj();
    var domainId = this.getDomainIdFromActiveDomain(activeDomain);
    // Fallback to known MEAWW News id if needed
    if (!domainId) domainId = 9704;

    var apiBase = this.getApiBase() || "http://localhost:4000";
    var url = apiBase + "/article/" + String(domainId) + "/new_video";

    // Build form-data
    var fd = new FormData();
    fd.append("video", this.state.file);
    fd.append("title", title);
    fd.append("description", (this.state.description || "").trim());
    fd.append("brand", this.state.category); // "Entertainment" | "News"

    // Debug logs
    console.log("API URL:", url);
    console.log("Active Domain:", activeDomain);
    console.log("Access Token:", accessToken ? "(present)" : "(missing)");
    console.log("Creating video with:", {
      title: title,
      description: (this.state.description || "").trim(),
      brand: this.state.category,
      file: {
        name: this.state.file.name,
        size: this.state.file.size,
        type: this.state.file.type || "video/mp4",
      },
    });

    var self = this;
    this.setState({ uploading: true, progress: 0, error: "", serverMessage: "" });

    axios.post(url, fd, {
      headers: {
        Authorization: accessToken || "",
      },
      timeout: 600000,
      onUploadProgress: function (pe) {
        if (!pe) return;
        var total = pe.total || 0;
        var loaded = pe.loaded || 0;
        var percent = total ? Math.round((loaded * 100) / total) : 0;
        self.setState({ progress: percent });
      },
      // With axios 0.20, XHR adapter is default in browser.
    })
    .then(function (res) {
      self.setState({
        uploading: false,
        serverMessage: "Upload complete.",
      });
      // if backend returns slug directly or nested in data/video object
      var slug =
        (res.data && res.data.slug) ||
        (res.data && res.data.video && res.data.video.slug) ||
        null;

      if (slug) {
        var videoUrl = "https://news.meaww.com/video/" + slug;
        console.log("Video URL:", videoUrl);
        self.setState({ serverMessage: "Upload complete: " + videoUrl });
        alert("Upload complete!\n\nVideo Link: " + videoUrl);
      } else {
        alert("Upload complete. No slug in response, check console for full response.");
      }
    })
    .catch(function (err) {
      console.error("Upload failed:", err);
      var msg = "Upload failed.";
      try {
        if (err && err.response && err.response.data) {
          msg += " " + (typeof err.response.data === "string"
            ? err.response.data
            : JSON.stringify(err.response.data));
        }
      } catch (e2) {}
      self.setState({ uploading: false, error: msg });
      alert(msg);
    });
  }

  render() {
    var s = this.state;
    return (
      <div style={containerStyle}>
        <h2 style={{ marginTop: 0 }}>Upload Video</h2>
        <form onSubmit={(e) => this.handleSubmit(e)} style={formStyle}>
          <label style={labelStyle}>
            Title<span style={{ color: "crimson" }}> *</span>
            <input
              type="text"
              value={s.title}
              onChange={(e) => this.setState({ title: e.target.value })}
              placeholder="Enter title"
              style={inputStyle}
              required
              disabled={s.uploading}
            />
          </label>

          <label style={labelStyle}>
            Description
            <textarea
              value={s.description}
              onChange={(e) => this.setState({ description: e.target.value })}
              placeholder="Enter short description"
              rows={4}
              style={{ ...inputStyle, resize: "vertical" }}
              disabled={s.uploading}
            />
          </label>

          <label style={labelStyle}>
            Category
            <select
              value={s.category}
              onChange={(e) => this.setState({ category: e.target.value })}
              style={inputStyle}
              disabled={s.uploading}
            >
              <option value="Entertainment">Entertainment</option>
              <option value="News">News</option>
            </select>
          </label>

          <label style={labelStyle}>
            Video File (MP4)<span style={{ color: "crimson" }}> *</span>
            <input
              type="file"
              accept="video/mp4"
              onChange={this.handleFileChange}
              style={inputStyle}
              disabled={s.uploading}
            />
          </label>

          {s.file ? (
            <div style={fileInfoStyle}>
              Selected: <strong>{s.file.name}</strong> ({s.file.size} bytes)
            </div>
          ) : null}

          {/* Progress bar */}
          {s.uploading ? (
            <div style={{ display: "grid", gap: 8 }}>
              <div style={progressWrap}>
                <div style={{ width: (s.progress || 0) + "%", ...progressBar }} />
              </div>
              <div style={{ fontSize: 12, color: "#57606a" }}>
                Uploading… {s.progress || 0}%
              </div>
            </div>
          ) : null}

          {s.serverMessage ? (
            <div style={okStyle}>{s.serverMessage}</div>
          ) : null}

          {s.error ? <div style={errorStyle}>{s.error}</div> : null}

          <button type="submit" style={buttonStyle} disabled={s.uploading}>
            {s.uploading ? "Uploading…" : "Upload Video"}
          </button>
        </form>
      </div>
    );
  }
}

// Redux mapStateToProps
function mapStateToProps(state) {
  return {
    login: state && state.login ? state.login : {},
  };
}

export default connect(mapStateToProps)(CreateNewArticleContainer);

// --- inline styles ---
const containerStyle = {
  maxWidth: 520,
  margin: "24px auto",
  padding: 16,
  border: "1px solid #e6e6e6",
  borderRadius: 12,
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
};

const formStyle = { display: "grid", gap: 12 };

const labelStyle = {
  display: "grid",
  gap: 6,
  fontSize: 14,
  color: "#1f2328",
};

const inputStyle = {
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d0d7de",
  fontSize: 14,
  outline: "none",
};

const buttonStyle = {
  padding: "10px 14px",
  borderRadius: 8,
  border: "1px solid #1f6feb",
  background: "#1f6feb",
  color: "white",
  fontSize: 14,
  cursor: "pointer",
};

const errorStyle = {
  color: "crimson",
  background: "#fff0f0",
  border: "1px solid #ffd6d6",
  padding: "8px 10px",
  borderRadius: 8,
};

const okStyle = {
  color: "#116329",
  background: "#e6ffec",
  border: "1px solid #abf2bc",
  padding: "8px 10px",
  borderRadius: 8,
};

const fileInfoStyle = {
  fontSize: 13,
  color: "#57606a",
};

const progressWrap = {
  width: "100%",
  height: 10,
  background: "#eef2f7",
  borderRadius: 999,
  overflow: "hidden",
  border: "1px solid #d0d7de",
};

const progressBar = {
  height: "100%",
  background: "#1f6feb",
  transition: "width 0.2s linear",
};
